export default "__VITE_ASSET__DjM_SABR__"